// extracted by mini-css-extract-plugin
module.exports = {"link":"DocsLink_link__2OU7w","load":"DocsLink_load__2PX20"};